import { Utils } from 'ecrion-components';

let cache = null;

function getMicroservicesInfo(environment) {
  if (cache) return Promise.resolve(cache);

  return Utils.request({
    method: 'GET',
    url: `${process.env.REACT_APP_WEBSITE_URL}/backend/microserviceinfo?environmentName=${environment}`,
  }).then((microservices) => {
    cache = microservices;
    return microservices;
  });
}

export { getMicroservicesInfo };
